/** Types + constants for the billing module. Plan codes, feature flags, and the shape returned by `getBillingState`. */

/** Canonical plan codes. Use `PLAN_CODE.X` everywhere instead of literal strings. */
export const PLAN_CODE = {
  FREE: "free",
  ENTERPRISE: "enterprise",
} as const;

export const PLAN_CODES = [PLAN_CODE.FREE, PLAN_CODE.ENTERPRISE] as const;
export type PlanCode = (typeof PLAN_CODES)[number];

/** Canonical feature keys gated by plan. Use `FEATURE.X` instead of literals. */
export const FEATURE = {
  WEARABLE_SYNC: "wearable_sync",
  EXPORT_DESTINATIONS: "export_destinations",
  BACKEND_SERVICES: "backend_services",
  CLINICAL_WORKFLOWS: "clinical_workflows",
  CUSTOM_EHR_CLIENT_IDS: "custom_ehr_client_ids",
  OCR: "ocr",
  DATA_STRUCTURING: "data_structuring",
} as const;

export const FEATURES = [
  FEATURE.WEARABLE_SYNC,
  FEATURE.EXPORT_DESTINATIONS,
  FEATURE.BACKEND_SERVICES,
  FEATURE.CLINICAL_WORKFLOWS,
  FEATURE.CUSTOM_EHR_CLIENT_IDS,
  FEATURE.OCR,
  FEATURE.DATA_STRUCTURING,
] as const;
export type Feature = (typeof FEATURES)[number];

/** App-layer view of a `billing_state` row. */
export type BillingState = {
  org_id: string;
  plan_code: PlanCode;
  active_patient_count: number;
  active_patient_limit: number;
  created_at: Date;
  updated_at: Date;
};

/** Billing linkage resolved for a claimed retrieval; `null` fields mean the account/org has no billing_state row yet. */
export type RetrievalBillingContext = {
  retrievalId: string;
  accountId: string;
  patientOrgMembershipId: string | null;
  organizationId: string | null;
  planCode: PlanCode | null;
  activePatientCount: number;
  activePatientLimit: number;
  firstFetchAt: Date | null;
};
